import { render, staticRenderFns } from "./palyingIcon.vue?vue&type=template&id=beec04c2&scoped=true&"
import script from "./palyingIcon.vue?vue&type=script&lang=js&"
export * from "./palyingIcon.vue?vue&type=script&lang=js&"
import style0 from "./palyingIcon.vue?vue&type=style&index=0&id=beec04c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beec04c2",
  null
  
)

export default component.exports